// @flow
import React, { Component } from 'react'
import Switcher from '../controls/Switcher'
import LabeledWrapper from './LabeledWrapper'
import type { OptionType } from '../types'

type Props = {|
  value: string,
  onChange: (string) => void
|}

const t = {
  label: 'Начальный статус',
  no_active_ads: 'Запущено',
  inactive: 'Остановлено'
}

export default class AudienceStatusSelect extends Component<Props> {
  render() {
    return (
      <LabeledWrapper label={t.label}>
        <Switcher
          options={this.options()}
          value={this.props.value}
          onChange={(status) => this.props.onChange(status)}
        />
      </LabeledWrapper>
    )
  }

  options(): Array<OptionType> {
    return [
      { id: 'no_active_ads', name: t.no_active_ads },
      { id: 'inactive', name: t.inactive }
    ]
  }
}
